import axios from "axios";
import { apiRoutes } from "../../../utils/constants";
import { popUp } from "../../../features/popUp/PopUp";
import { getAuthToken } from "../../sessionStorage/getAuthToken";

const getCategoriesApi = async (projectId: any) => {
  const authInfo: any = getAuthToken();
  const data: any = JSON.parse(authInfo);

  return await axios[apiRoutes.GET_CATEGORIES.request](
    `${apiRoutes.GET_CATEGORIES.url}?projectId=${projectId}&page=1&pageSize=500`,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${data.token}`,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response: any) => {
      if (response.data) {
        return response.data;
      } else {
        popUp({
          type: "failure",
          message: "Oops! There was a problem in getCategoriesApi",
        });
      }
    })
    .catch((error: any) => {
      console.log("error: ", error);
      const dataError = error.response.data.errors;
      if (dataError) {
        dataError.map((err: any) => {
          popUp({ type: "failure", message: err.message });
        });
      } else {
        popUp({ type: "failure", message: "Oh, something went wrong!" });
      }
    });
};

export default getCategoriesApi;
